import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { TheoryPractice } from './components/TheoryPractice';
import { Volumes } from './components/Volumes';
import { FitCheck } from './components/FitCheck';
import { Bonuses } from './components/Bonuses';
import { StickyBuyBar } from './components/StickyBuyBar';
import { LaunchUrgency } from './components/LaunchUrgency';
import { Offer } from './components/Offer';
import { TestimonialWall } from './components/TestimonialWall';
import { Guarantee } from './components/Guarantee';
import { FormatNotice } from './components/FormatNotice';
import { Faqs } from './components/Faqs';
import { Contact } from './components/Contact';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    initMetaPixel();
  }, []);
  return <div lang="pl" className="w-full bg-night pb-[68px] font-sans text-cream sm:pb-0" data-id="element-0" data-mp="2zl39tfhhuw2o">
      <noscript data-id="element-1" data-mp="2zn678kkz7rhf">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="33morde4z3yj7" />
      </noscript>
      <PromoBar data-id="element-3" data-mp="3dl4mds74frxz" />
      <Hero data-id="element-4" data-mp="3dlnu6g324zya" />
      <SocialProofBar data-id="element-5" data-mp="3dmfozootytni" />
      <QuickTestimonials data-id="element-6" data-mp="3dii4aymltu1i" />
      <Problems data-id="element-7" data-mp="nw2ay2pqvkpi" />
      <SystemOverview data-id="element-8" data-mp="nwc582htoe10" />
      <TheoryPractice data-id="element-9" data-mp="nv0xjrl9am4m" />
      <Volumes data-id="element-10" data-mp="nxn9e3f6jnsn" />
      <FitCheck data-id="element-11" data-mp="sunb624zy4dy" />
      <Bonuses data-id="element-12" data-mp="su43de928wdn" />
      <LaunchUrgency data-id="element-13" data-mp="stko65asom3b" />
      <Offer data-id="element-14" data-mp="st2kinlsz5ld" />
      <TestimonialWall data-id="element-15" data-mp="swqaxdvybbvv" />
      <Guarantee data-id="element-16" data-mp="36859fxwiety" />
      <FormatNotice data-id="element-17" data-mp="35oymvdpbcv8" />
      <Faqs data-id="element-18" data-mp="356t1855fman" />
      <Comparison data-id="element-19" data-mp="34x4zq3nzp7l" />
      <FinalCall data-id="element-20" data-mp="38ktgau95lfg" />
      <ClosingWords data-id="element-21" data-mp="3uct0zcywiaxb" />
      <Contact data-id="element-22" data-mp="3udkos1m9b4d1" />
      <SiteFooter data-id="element-23" data-mp="3ubzt28o7hfdl" />
      <StickyBuyBar data-id="element-24" data-mp="3ucjbrrlok7so" />
    </div>;
}